export default __webpack_public_path__ + "static/skills-tag-colored-light-f5ad91750dd9f2d11d4be84bb60e77ed.png";